import { render, staticRenderFns } from "./milksite.vue?vue&type=template&id=241dd420&scoped=true&"
import script from "./milksite.vue?vue&type=script&lang=js&"
export * from "./milksite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241dd420",
  null
  
)

export default component.exports